import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import "../styles/AboutUs.css";
import aboutImage from "../assets/images/PriniCrackers.jpg";

const AboutUsData = {
  intro:
    "Welcome to our Diwali celebration platform — your trusted guide to a joyful, safe, and eco-friendly festival of lights.",
  sections: [
    {
      title: "Our Mission",
      content:
        "We strive to promote awareness about Diwali safety, sustainability, and traditions so that everyone can celebrate with happiness and peace of mind.",
    },
    {
      title: "Who We Are",
      content:
        "We are a passionate group of festival enthusiasts, safety advocates, and community builders committed to making Diwali celebrations brighter and safer for families across the globe.",
    },
    {
      title: "What We Offer",
      listItems: [
        "Expert tips on safe handling of fireworks and decorations",
        "Information on eco-friendly and sustainable festival practices",
        "Engaging content and community support for a memorable Diwali",
      ],
    },
    {
      title: "Get In Touch",
      content:
        "Questions or feedback? We'd love to hear from you! Reach out via email or social media, and join us in spreading safe and joyful celebrations.",
      isContactSection: true, // flag to identify this section
    },
  ],
};

const AboutUs = () => {
  return (
    <div className="about-page">
      <h2>About Us</h2>
      <p className="about-intro">{AboutUsData.intro}</p>

      <div className="about-content">
        <div className="about-text">
          {AboutUsData.sections.map(({ title, content, listItems, isContactSection }, idx) => (
            <div key={idx} className="about-section">
              <h3>{title}</h3>
              {content && <p>{content}</p>}
              {listItems && (
                <ul>
                  {listItems.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
              {isContactSection && (
                <Link to="/contact" className="btn">
                  Contact Us
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="about-image-wrapper">
          <img src={aboutImage} alt="Diwali celebration" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
